var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "search-path-1",
    points: "0 4.95e-05 12.128985 4.95e-05 12.128985 12.1275 0 12.1275"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-537.000000, -29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-icon",
    transform: "translate(537.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "search-mask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search-path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.989901,4.9846995 C0.989901,2.7819495 2.781801,0.9900495 4.980096,0.9900495 C7.182351,0.9900495 8.969301,2.7819495 8.969301,4.9846995 C8.969301,7.1824995 7.182351,8.9743995 4.980096,8.9743995 C2.781801,8.9743995 0.989901,7.1824995 0.989901,4.9846995 M11.983851,11.2860495 L8.830701,8.1328995 C9.533601,7.2715995 9.959301,6.1776495 9.959301,4.9846995 C9.959301,2.2374495 7.726851,4.95e-05 4.980096,4.95e-05 C2.232351,4.95e-05 -9.9e-05,2.2374495 -9.9e-05,4.9846995 C-9.9e-05,7.7269995 2.232351,9.9643995 4.980096,9.9643995 C6.177501,9.9643995 7.276401,9.5386995 8.137701,8.8357995 L11.280951,11.9839995 C11.379951,12.0829995 11.503701,12.1275495 11.632401,12.1275495 C11.761101,12.1275495 11.884851,12.0829995 11.983851,11.9839995 C12.177396,11.7909495 12.177396,11.4790995 11.983851,11.2860495",
    fill: "currentColor",
    mask: "url(#search-mask)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.258212198bdd15d92c214baa2d076651.svg";
export { ForwardRef as ReactComponent };